import { UseEditableWidgetBackend } from '@procureai/ui-modules-mui';

import { createEditableWidgetGraphqlBackendHook } from '@/shared/hooks/useEditableWidgetGraphqlBackend/useEditableWidgetGraphqlBackend';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { AWARDING_CONFIGURATION_WIDGET_MUTATION as AWARDING_CONFIGURATION_WIDGET_MUTATION } from './AwardingConfigurationWidget.mutation';
import { AWARDING_CONFIGURATION_WIDGET_QUERY as AWARDING_CONFIGURATION_WIDGET_QUERY } from './AwardingConfigurationWidget.query';
import {
  AwardingConfigurationFormData,
  awardingConfigurationFormSchema,
  toAwardingConfigurationFormData,
} from './AwardingConfigurationWidget.schema';

const useAwardingConfigurationWidgetBackendInternal = createEditableWidgetGraphqlBackendHook({
  schema: awardingConfigurationFormSchema,
  query: AWARDING_CONFIGURATION_WIDGET_QUERY,
  mutation: AWARDING_CONFIGURATION_WIDGET_MUTATION,
});

export const useAwardingConfigurationWidgetBackend: UseEditableWidgetBackend<AwardingConfigurationFormData> = ({
  i18n,
}) => {
  const { entityId } = useModuleContext();
  const variables = { id: entityId };

  return useAwardingConfigurationWidgetBackendInternal({
    i18n,
    variables,
    skip: !entityId,
    toFormData: (data) => toAwardingConfigurationFormData(data.tesseract.demand.awardingConfiguration),
    toMutationData: (formData) => {
      return {
        id: entityId,
        awardingConfiguration: {
          performAutomaticAwarding: formData.automation.enabled,
          deadlineDays: formData.deadline.days,
          rules: formData.rules.map((rule) => ({
            variant: rule.variant,
            // TODO: price deviation support will be added in https://procureai.atlassian.net/browse/APP-3099
          })),
        },
      };
    },
    toSimpleFormWidgetProps(data, loading) {
      const deadline = data?.tesseract.demand.awardingConfiguration.deadline;
      return {
        deadline,
        disabled: loading || deadline,
      };
    },
  });
};
